import Boton from "./Boton"
import "../Info.css"

const LM =()=>{
    return(
        <div className="infoalbum">
        <h1 className="title"> DYSTOPIA: LOSE MYSELF</h1>
        <div className="infoal">
        <div className="infotext">
            <Boton/>    
  <p>-Beneficio de Preventa (POBs) = desde <span className="colorunoa">11usd</span> <span className="colordosa"> 15 usd</span></p>
  <p>-Poster de preventa=  <span className="colorunoa">1,5usd</span> <span className="colordosa"> 4 usd</span></p>
  <p>-Standee = <span className="colorunoa">2usd</span> <span className="colordosa"> 5 usd</span></p>
  <p>-Stickers = <span className="colorunoa">0,75usd</span> <span className="colordosa"> 1 usd</span> </p>
  <p className="ver">LIMITADO (ver. S)</p>
  <p>-Photobook Limitado (cd+pb) = <span className="colorunoa">14usd</span> <span className="colordosa"> 20 usd</span></p>
  <p>-Photocard =<span className="colorunoa">4,5usd</span> <span className="colordosa"> 5 usd</span></p>
  <p>-Cover-up Card =  <span className="colorunoa">2usd</span> <span className="colordosa"> 5 usd</span></p>
  <p>-DIY Dreamcatcher kit + Bookmark= <span className="colorunoa">2usd</span> <span className="colordosa"> 8 usd</span></p>
  <p>-LIMITADO de Preventa (ver. D)</p>
  <p>-Photobook (cd+pb) = <span className="colorunoa">12usd</span> <span className="colordosa"> 15 usd</span></p>
  <p>-Photocard limitada = <span className="colorunoa">7usd</span> <span className="colordosa"> 10 usd</span></p>
  <p className="ver">NORMAL (H,E ver.)</p>
  <p>-Photobook =<span className="colorunoa">10usd</span> <span className="colordosa"> 12 usd</span> </p>
  <p>-Photocard =<span className="colorunoa">4,5usd</span> <span className="colordosa"> 6 usd</span></p>
  </div>
  <img src="https://krmerchs.com/cdn/shop/products/322fe10b4c352c8e46a4c69b36993f01.jpg?v=1620410632"style={{ boxShadow: "3.5px 3.5px 0px rgb(0, 0, 155)" }} />
  <img src="https://pbs.twimg.com/media/Efx2OR4WkAE7RaM.jpg:large"style={{ boxShadow: "3.5px 3.5px 0px rgb(0, 0, 155)" }} />
</div>
        </div>
    )
}

export default LM